import { Component, OnInit } from '@angular/core';
import {environment} from '../../environments/environment';
import {ConfService} from '../conf.service';
import {ConnecttocrudService} from '../connecttocrud.service';
import {KongService} from '../kong.service';

@Component({
  selector: 'app-bulkscripts',
  templateUrl: './bulkscripts.component.html',
  styleUrls: ['./bulkscripts.component.scss']
})
export class BulkscriptsComponent implements OnInit {

  partners: any;

  applicationPermissionConfig: any;

  forCreated = [];

  permissionIDArray = [];
  permissionGroupId: any;

  constructor(public confPost: ConfService, public _service: ConnecttocrudService, public kong: KongService) { }

  patchDefaultConsumerGroupToConsumer(consumer) {
    return new Promise((resolve, reject) => {
      const temp = consumer['custom_id'].split('-');
      let partnerShortCode = '';
      if (temp.length > 1) {
        partnerShortCode = temp[temp.length - 1];
      } else {
        partnerShortCode = consumer['custom_id'];
      }
      this.kong.getKongGatewayCredentialDetails('acls', consumer['id']).subscribe(response => {
        if (response && response['data'].length > 0) {
          let isFound = false;
          for (const group of response['data']) {
            if (group) {
              if (group['group'] === partnerShortCode) {
                isFound = true;
                break;
              }
            } else {
              resolve('success');
            }
          }
          if (isFound === true) {
            resolve('success');
          } else {
            this.kong.postKongGatewayAPIkeyDetails(consumer['id'], {group: partnerShortCode}, 'acls').subscribe(async cons1 => {
              resolve('success');
            }, async error => {
              resolve('failed');
            });
          }
        } else {
          this.kong.postKongGatewayAPIkeyDetails(consumer['id'], {group: partnerShortCode}, 'acls').subscribe(async cons2 => {
            resolve('success');
          }, async error => {
            resolve('failed');
          });
        }
      }, error => {
        resolve('failed');
      });
    });
  }

  patchDefaultTagToConsumer(consumer) {
    return new Promise((resolve, reject) => {
      const temp = consumer['custom_id'].split('-');
      let partnerShortCode = '';
      if (temp.length > 1) {
        partnerShortCode = temp[temp.length - 1];
      } else {
        partnerShortCode = consumer['custom_id'];
      }
      if (consumer['tags'] === null || consumer['tags'] === undefined || consumer['tags'].length === 0) {
        this.kong.patchTagToConsumer(consumer['id'], {tags: [partnerShortCode]}).subscribe(resp => {
          resolve('success');
        }, error => {
          resolve('failed');
        });
      } else {
        let isFound = false;
        for (const tag of consumer['tags']) {
          if (tag) {
            if (tag === partnerShortCode) {
              isFound = true;
              break;
            }
          } else {
            resolve('success');
          }
        }
        if (isFound === true) {
          resolve('success');
        } else {
          const tagsArray = consumer['tags'];
          tagsArray.push(partnerShortCode);
          this.kong.patchTagToConsumer(consumer['id'], {tags: tagsArray}).subscribe(resp => {
            resolve('success');
          }, error => {
            resolve('failed');
          });
        }
      }
    });
  }

  updateAllConsumers(offset) {
    this.kong.getAllConsumers(offset).subscribe(async response => {
      for (let i = 0; i < response['data'].length; i++) {
        // await this.patchDefaultConsumerGroupToConsumer(response['data'][i]);
        // await this.patchDefaultTagToConsumer(response['data'][i]);
        // await this.patchCustomIdAsEmailInKong(response['data'][i]);
        // await this.retainOldConsumerDetailsInNewKong(response['data'][i]);
      }
      if (response.hasOwnProperty('offset')) {
        this.updateAllConsumers(response['offset']);
      }
    });
  }

  createAdminUsersForExistingAdmins() {
    this._service.getItems('v2', 'services', 'services', 'settings', false).subscribe(async response => {
      this.partners = response;
      const adminUsers = this.partners.filter((partner) => partner['partner'].includes('admin-'));
      for (const user of adminUsers) {
        if (user) {
          await this.checkAndAddAdminUser(user);
        }
      }
    });
  }

  checkAndAddAdminUser(user) {
    return new Promise((resolve, reject) => {
      this.confPost.getData('access', 'access', 'v1', 'users', 'user=' + user['partner']).subscribe(async response => {
        let resp: any;
        resp = response;
        if (!(resp && resp.length > 0)) {
          await this.createAdminUser(user);
          resolve('success');
        } else {
          resolve('success');
        }
      }, error => {
        resolve('failed');
      });
    });
  }

  createAdminUser(admin) {
    return new Promise(async (resolve, reject) => {
      const userPayload = {
        partner: '',
        user: '',
        email: '',
        created_by: '',
        last_updated_by: '',
        environments: [],
        user_token: '',
        status: true
      };

      const temp = admin['partner'].split('-');
      userPayload.partner = temp[temp.length - 1];
      // userPayload.account = temp[temp.length - 1];
      userPayload.user = admin['partner'];
      userPayload.email = admin['email'];
      userPayload.created_by = admin['email'];
      userPayload.last_updated_by = admin['email'];
      userPayload['last_updated_at'] = Date.now();
      userPayload['created_at'] = Date.now();

      for (const env of admin['environments']) {
        if (env) {
          await this.setUserPayloadEnvironments(env, userPayload);
        }
      }
      this._service.addItem(userPayload, 'v1', 'access', 'access', 'users').subscribe(async resp => {
        resolve('success');
      }, async error1 => {
        resolve('failed');
      });
    });
  }

  setUserPayloadEnvironments(env, userPayload) {
    return new Promise((resolve, reject) => {
      const envObject = {
        name: '',
        roles: [],
        password: '',
        shash: '',
        ralam: '',
        exclusions: {
          permissions: [],
          permission_groups: [],
          roles: []
        },
        audit_logs: [
          {
            action: '',
            by: ''
          }
        ]
      };
      this.confPost.getPartnerDirectly(env['name']).subscribe(data => {
        this.confPost.generatePartnerKey(data['partner'], data['partner'], data['partnerKey']).subscribe(response => {
          userPayload.user_token = response['token'];
          envObject.name = env['name'];
          if (env['type'] === 'admin') {
            envObject.roles = [1];
          } else {
            envObject.roles = [2];
          }
          envObject.audit_logs[0]['at'] = Date.now();
          envObject.audit_logs[0]['action'] = 'CREATE';
          envObject.audit_logs[0]['by'] = data['primary_email'];
          envObject.password = data['account_password'];
          envObject.shash = data['shash'];
          envObject.ralam = data['ralam'];
          userPayload.environments.push(envObject);
          resolve('success');
        }, async error => {
          resolve('failed');
        });
      }, error1 => {
        resolve('failed');
      });
    });
  }

  patchCustomIdAsEmailInKong(consumer) {
    return new Promise((resolve, reject) => {
      if (consumer['username'] === consumer['custom_id']) {
        resolve('success');
      } else {
        this.kong.patchTagToConsumer(consumer['id'], {'custom_id': consumer['username']}).subscribe(resp => {
          resolve('success');
        }, error => {
          resolve('failed');
        });
      }
    });
  }

  getRolesForAPartner(partner) {
    return new Promise((resolve, reject) => {
      this._service.getItemswithParameter('v1', 'access', 'access', 'roles', 'fields=role&partner=' + partner).subscribe(response => {
        resolve({rolesResponse: response});
      }, error => {
        resolve({rolesResponse: 'failed'});
      })
    })
  }

  createAccountRolesForExistingUsers() {
    const rolePayload = {
      "role": '',
      "permission_groups": [],
      "permissions": [],
      "roles": [],
      "exclusions": [],
      "partner": '',
      "account": '',
      "description": ''
    };
    let rolesResponse: any;
    let usersResponse: any;
    // this._service.getItemswithParameter('v1', 'access', 'access', 'roles', 'fields=role').subscribe(response => {
    //   rolesResponse = response;
    this._service.getItemswithParameter('v1', 'access', 'access', 'users', '').subscribe(async response1 => {
      usersResponse = response1;
      for (const user of usersResponse) {
        if (user && (user['partner'] === 'billings')) {
          for (const env of user['environments']) {
            env['account'] = env['name'];
            await this.getRolesForAPartner(env['name']).then(async response2 => {
              if(response2 && response2['rolesResponse'] !== 'failed') {
                rolesResponse = response2['rolesResponse'];
                if (rolesResponse.filter((object) => object['role'] === env['name'] + '=>' + env['name'] + '=>' + user['email']).length === 0) {
                  rolePayload['role'] = env['name'] + '=>' + env['name'] + '=>' + user['email'];
                  rolePayload['partner'] = env['name'];
                  rolePayload['account'] = env['name'];
                  await this.createRoleForEachUserForEachEnvironment(rolePayload);
                }
              }
            });
          }
        }
        if (user) {
          await this.putExistingUsers(user);
        }
      }
    });

    // });
  }

  putExistingUsers(payload) {
    return new Promise((resolve, reject) => {
      this._service.putItem('v1', 'access', 'access', 'users', payload, payload['id']).subscribe(response => {
        resolve('success');
      }, error => {
        resolve('failed');
      });
    });
  }

  createRoleForEachUserForEachEnvironment(roleDetail) {
    return new Promise((resolve, reject) => {
      this._service.addItem(roleDetail, 'v1', 'access', 'access', 'roles').subscribe(async data => {
        if (data) {
          resolve('success');
        } else {
          resolve('failed');
        }
      }, error => {
        resolve('failed');
      });
    });
  }

  assignAccountRolesToExistingUsers() {
    let usersResponse: any;
    let rolesResponse: any;
    this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'roles', '').subscribe(response => {
      if (response) {
        rolesResponse = response;
        this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'users', '').subscribe(async response1 => {
          usersResponse = response1;
          for (const user of usersResponse) {
            if (user) {
              for (const env of user['environments']) {
                if (rolesResponse.filter((object) => object['role'] === env['name'] + '=>' + env['name'] + '=>' + user['email']).length === 1) {
                  const role = rolesResponse.filter((object) => object['role'] === env['name'] + '=>' + env['name'] + '=>' + user['email']);
                  env['roles'].push(role[0]['id']);
                }
              }
            }
            if (user) {
              await this.putExistingUsers(user);
            }
          }
        });
      }
    });
  }

  getApplicationPermissionGroupConfig() {
    return new Promise((resolve, reject) => {
      this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'applicationpermissiongroupconfig', null).subscribe(response => {
        if (response) {
          this.applicationPermissionConfig = response;
          resolve('success');
        } else {
          resolve('failed');
        }
      }, error => {
        resolve('failed');
      });
    });
  }


  // createApplicationPermission(payload, count) {
  //     return new Promise((resolve, reject) => {
  //         this._service.addItem(payload, 'v1', environment.accessPartner, environment.accessPartner, 'permissions').subscribe(async response => {
  //             this.permissionIDArray.push(response['upsertedId']);
  //             resolve('success');
  //         }, async error => {
  //             if (error && error.status === 424) {
  //                 if (error.message && error.message.includes('permission dup key')) {
  //                     reject('duplicate');
  //                 } else {
  //                     if (count <= 5) {
  //                         count = count + 1;
  //                         // setTimeout(async () => {
  //                         //     resolve(await this.createApplicationPermission(payload));
  //                         // }, 3000);
  //                         this.createApplicationPermission(payload, count);
  //                     } else {
  //                         reject('failed');
  //                     }
  //                 }
  //             }
  //         });
  //     });
  // }

  createPermission(payload) {
    return new Promise((resolve, reject) => {
      this._service.addItem(payload, 'v1', environment.accessPartner, environment.accessPartner, 'permissions').subscribe(async response => {
        this.permissionIDArray.push(response['upsertedId']);
        resolve({response: 'success'});
        return;
      }, async error => {
        if (error && error.status === 424) {
          if (error.hasOwnProperty('message') && error['message'].includes('dup key')) {
            throw {response: 'duplicate'};
          }
        }
        throw {response: 'failed'};
      });
    });
  }

  // createApplicationPermission(payload, count) {
  //     const that = this;
  //     function doo() {
  //         // always return a promise
  //         return that.createPermission(payload).then(function(){
  //             return Promise.resolve();
  //         }).catch(async function(err) {
  //             if (err && err.hasOwnProperty('response') && err['response'] === 'failed') {
  //                 // if (count <= 5) {
  //                     await doo().then(() => {
  //                         return Promise.resolve();
  //                     }).catch(async function(err1) {
  //                         return Promise.resolve();
  //                     });
  //                 // }
  //             } else if (err && err.hasOwnProperty('response') && err['response'] === 'duplicate') {
  //                 return Promise.resolve();
  //             }
  //         });
  //     }
  //     return doo(); // returns a promise
  // }

  createApplicationPermission(payload, count) {
    return new Promise((resolve, reject) => {
      // this.confPost.getData(environment.accessPartner, environment.accessPartner, 'v1', 'permissions', 'permission=' + payload['permission']).subscribe(resp => {
      //     let permissionResponse: any;
      //     permissionResponse = resp;
      //     if (permissionResponse.length === 0) {
      this._service.addItem(payload, 'v1', environment.accessPartner, environment.accessPartner, 'permissions').subscribe(async response => {
        this.permissionIDArray.push(response['upsertedId']);
        resolve('success');
      }, async error => {
        if (error && error.status === 424) {
          if (error && error.hasOwnProperty('message') && error['message'].includes('dup')) {
            resolve('success');
          } else {
            this._service.addItem(payload, 'v1', environment.accessPartner, environment.accessPartner, 'permissions').subscribe(async response => {
              this.permissionIDArray.push(response['upsertedId']);
              resolve('success');
            }, async error1 => {
              if (error1 && error1.status === 424) {
                if (error1 && error1.hasOwnProperty('message') && error1['message'].includes('dup')) {
                  resolve('success');
                } else {
                  this._service.addItem(payload, 'v1', environment.accessPartner, environment.accessPartner, 'permissions').subscribe(async response => {
                    this.permissionIDArray.push(response['upsertedId']);
                    resolve('success');
                  }, async error2 => {
                    resolve('failed');
                  });
                }
              }
            });
          }
        }
      });
      // } else {
      //     resolve('success');
      // }
      // });
    });
  }

  createApplicationPermissionGroup(payload, count) {
    return new Promise((resolve, reject) => {
      this._service.addItem(payload, 'v1', environment.accessPartner, environment.accessPartner, 'permissiongroups').subscribe(async response => {
        this.permissionGroupId = response['upsertedId'];
        resolve('success');
      }, async error => {
        if (error && error.status === 424) {
          if (error.message && error.message.includes('permission dup key')) {
            resolve('duplicate');
          } else {
            if (count <= 5) {
              count = count + 1;
              // setTimeout(async () => {
              //     resolve(await this.createApplicationPermission(payload));
              // }, 3000);
              await this.createApplicationPermissionGroup(payload, count);
              resolve();
            } else {
              resolve('failed');
            }
          }
        }
      });
    });
  }

  returnPermissionsPayloadArray(partner, account, apiName, version, configs, permissionsBulkPayload) {
    if (configs && configs.length > 0) {
      for (const action of configs[0]['actions']) {
        const payload = {
          permission: '',
          partner: partner,
          account: account
        };
        payload['permission'] = action + ':' + partner + '=>' + account + '=>' + apiName + '=>' + version;
        payload['display_name'] = action + ':' + apiName + '=>' + version;
        payload['type'] = 'account';
        permissionsBulkPayload.push(payload);
      }
    }
    return permissionsBulkPayload;
  }

  associateApplicationPermissionGroupWithApplicationRole(partner, account, email, idToBeAssociated) {
    return new Promise((resolve, reject) => {
      this.confPost.getData(environment.accessPartner, environment.accessPartner, 'v1', 'roles', 'role=' + partner + '=>' + account + '=>' + email + '&dbref=false').subscribe(response => {
        if (response && response[0]) {
          const permissionGroups = response[0]['permission_groups'];
          permissionGroups.push(idToBeAssociated);
          this.confPost.patchEntityData(environment.accessPartner, environment.accessPartner, 'v1', 'roles', response[0]['id'], {'permission_groups': permissionGroups}).subscribe(response1 => {
            resolve('success');
          }, error => {
            resolve('failed');
          });
        } else {
          resolve('failed');
        }
      }, error => {
        resolve('failed');
      });
    });
  }

  deletePermissionsCreatedSoFar(permissionsIdArray) {
    let idString = '';
    for (let i = 0; i < permissionsIdArray.length; i++) {
      if (permissionsIdArray[i]) {
        idString = idString + permissionsIdArray[i].toString();
        if (i !== permissionsIdArray.length - 1) {
          idString = idString + ',';
        }
      }
    }
    this.confPost.deleteDataForAnEntity(environment.accessPartner, environment.accessPartner, environment.accessPkey, 'permissions', 'v1', 'id.in=' + idString).subscribe(response => {
    });
  }

  async createBulkPermissions(partner, account, APIName, version, email, permissionsPayload) {
    this.permissionIDArray = [];
    this.permissionGroupId = 0;
    let isError = false;
    // for (const payload of permissionsPayload) {
    for (let i = 0; i < permissionsPayload.length; i++) {
      const payload = permissionsPayload[i];
      if (payload) {
        // const id = await this.createApplicationPermission(payload, 0);
        // if (id !== 'failed' && id !== 'duplicate') {
        //     permissionIDArray.push(id);
        // } else {
        // isError = true;
        // break;
        // }
        await this.createApplicationPermission(payload, 0);
      }
    }
    // if (!isError) {
    const permissionGroupPayload = {
      permissionGroup: partner + '=>' + account + '=>' + APIName + '=>' + version,
      partner: partner,
      account: account
    };
    permissionGroupPayload['permissions'] = this.permissionIDArray;
    permissionGroupPayload['display_name'] = APIName + ' (' + version + ')';
    permissionGroupPayload['type'] = 'account';
    await this.createApplicationPermissionGroup(permissionGroupPayload, 0);
    // if (permissionGroupId !== 'failed' && permissionGroupId !== 'duplicate') {
    if (this.permissionGroupId !== 0) {
      await this.associateApplicationPermissionGroupWithApplicationRole(partner, account, email, this.permissionGroupId);
      // if (status === 'failed') {
      //     this.deletePermissionsCreatedSoFar(permissionIDArray);
      //     this.confPost.deleteDataForAnEntity(environment.accessPartner, environment.accessPartner, environment.accessPkey, 'permissiongroups', 'v1', 'id=' + permissionGroupId).subscribe(response => {
      //     });
      // }
    }
    // else {
    // this.deletePermissionsCreatedSoFar(permissionIDArray);
    // }
    // } else {
    //     // this.deletePermissionsCreatedSoFar(permissionIDArray);
    // }
  }

  generateAccountPermissions(partner, account, APIName, version, type) {

    const permissionsbulkPayload = [];
    const apiManagementConfig = this.applicationPermissionConfig.filter(element => element['type'] === 'APIMANAGEMENT');
    const documentationConfig = this.applicationPermissionConfig.filter(element => element['type'] === 'DOCUMENTATION');
    const schedulerConfig = this.applicationPermissionConfig.filter(element => element['type'] === 'SCHEDULER');

    let finalPermissionsBulkPayload: any;

    switch (type) {
      case 'DAAS':
        const DAASPermissionConfig = this.applicationPermissionConfig.filter(element => element['type'] === type);
        if (DAASPermissionConfig && DAASPermissionConfig.length > 0) {
          for (const action of DAASPermissionConfig[0]['actions']) {
            const payload = {
              permission: '',
              partner: partner,
              account: account,
            };
            payload['permission'] = action + ':' + partner + '=>' + account + '=>' + APIName + '=>' + version;
            payload['display_name'] = action + ':' + APIName + '=>' + version;
            payload['type'] = 'account';
            permissionsbulkPayload.push(payload);
          }
        }
        const dataPermissionConfig = this.applicationPermissionConfig.filter(element => element['type'] === 'DATA');
        if (dataPermissionConfig && dataPermissionConfig.length > 0) {
          for (const action of dataPermissionConfig[0]['actions']) {
            const payload = {
              permission: '',
              partner: partner,
              account: account,
            };
            payload['permission'] = action + ':' + partner + '=>' + account + '=>' + APIName + '=>' + version;
            payload['display_name'] = action + ':' + APIName + '=>' + version;
            payload['type'] = 'account';
            permissionsbulkPayload.push(payload);
          }
        }
        finalPermissionsBulkPayload = this.returnPermissionsPayloadArray(partner, account, APIName, version, apiManagementConfig, permissionsbulkPayload);
        finalPermissionsBulkPayload = this.returnPermissionsPayloadArray(partner, account, APIName, version, documentationConfig, finalPermissionsBulkPayload);
        return finalPermissionsBulkPayload;
        break;
      default:
        const permissionConfig = this.applicationPermissionConfig.filter(element => element['type'] === type);
        if (permissionConfig && permissionConfig.length > 0) {
          for (const action of permissionConfig[0]['actions']) {
            const payload = {
              permission: '',
              partner: partner,
              account: account,
            };
            payload['permission'] = action + ':' + partner + '=>' + account + '=>' + APIName + '=>' + version;
            payload['display_name'] = action + ':' + APIName + '=>' + version;
            payload['type'] = 'account';
            permissionsbulkPayload.push(payload);
          }
        }
        finalPermissionsBulkPayload = this.returnPermissionsPayloadArray(partner, account, APIName, version, apiManagementConfig, permissionsbulkPayload);
        finalPermissionsBulkPayload = this.returnPermissionsPayloadArray(partner, account, APIName, version, documentationConfig, finalPermissionsBulkPayload);
        finalPermissionsBulkPayload = this.returnPermissionsPayloadArray(partner, account, APIName, version, schedulerConfig, finalPermissionsBulkPayload);
        return finalPermissionsBulkPayload;
        break;
    }
  }

  async generateAccountRolePermissionGroupAndPermissions(partner, account, email, APIName, version, type) {
    if (!this.applicationPermissionConfig) {
      await this.getApplicationPermissionGroupConfig();
    }

    let finalPermissionsBulkPayload: any;

    finalPermissionsBulkPayload = this.generateAccountPermissions(partner, account, APIName, version, type);
    await this.createBulkPermissions(partner, account, APIName, version, email, finalPermissionsBulkPayload);
  }

  createAccountPermissionsAndGroupsForAllExistingAPIs() {
    const partnersToOmit = ['linkzy', 'excelonacad', 'dev-excelonacad', 'satellite', 'hubspire', 'dev-taskbench', 'dev-linkzy', 'dev-satellite', 'dev-election', 'dev-medsec', 'dev-sandhata', 'dev-sam123',
      'qa-sam123', 'dev-gsam', 'dev-kassu', 'dev-shanthan', 'access', 'dev-access', 'test-malarvikram', 'services', 'commons', 'automation-hari0101', 'dev-linxmgt', 'malarvikram', 'qa-muthu'];
    let rolesResponse: any;
    // this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'roles', '').subscribe(roles => {
    //   rolesResponse = roles;
    this.confPost.getAllPartners().subscribe(async response => {
      let partners: any;
      partners = response;
      if (response) {
        for (let i = 0; i < partners.length; i++) {
          const partner = partners[i];
          if (!(partnersToOmit.includes(partner['partner']))) {
            if (partner['partner'] === 'billings') {
              await this.getRolesForAPartner(partner['partner']).then(async resp1 => {
                rolesResponse = resp1['rolesResponse'];
                for (let j = 0; j < partner['accounts'].length; j++) {
                  const account = partner['accounts'][j];
                  if (account && rolesResponse.filter((object) => object['role'] === partner['partner'] + '=>' + account['account_id'] + '=>' + account['account_email']).length > 0) {
                    for (const entity of account['entities']) {
                      if (entity) {
                        await this.generateAccountRolePermissionGroupAndPermissions(partner['partner'], account['account_id'], account['account_email'], entity['entityname'], entity['version'], 'DAAS');
                      }
                    }
                  }
                }
                for (let j = 0; j < partner['accounts'].length; j++) {
                  const account = partner['accounts'][j];
                  if (account && rolesResponse.filter((object) => object['role'] === partner['partner'] + '=>' + account['account_id'] + '=>' + account['account_email']).length > 0) {
                    this.confPost.getAllExecutorsOfPartner(partner['partner'], account['account_id'], partner['partnerKey']).subscribe(async executorsResponse => {
                      if (executorsResponse) {
                        let executors: any;
                        executors = executorsResponse;
                        for (const executor of executors) {
                          if (executor && executor['executor_type'] !== 'API') {
                            await this.generateAccountRolePermissionGroupAndPermissions(partner['partner'], account['account_id'], account['account_email'], executor['executor_name'], executor['executor_version'], executor['executor_type']);
                          }
                        }
                      }
                    });

                  }
                }
              });
            }
          }
        }
      }
    });
    // });
  }

  patchThirdPartyAPI(partner, account, pkey, executor) {
    return new Promise((resolve, reject) => {
      this.kong.getServicesFromApiGatewayByNameOrId(partner + '-' + account + '-' + executor['executor_name'] + '-' + executor['executor_version']).subscribe(resp => {
        if (resp) {
          executor['registeredAsIs'] = false;
          this.confPost.updateApiExecutorForPartnerAccountWithPkey(partner, account, pkey, executor['id'], executor).subscribe(response => {
            resolve('success');
          }, error => {
            resolve('failed');
          });
        } else {
          resolve('success');
        }
      }, error => {
        resolve('success');
      });
    });
  }

  patchThirdPartyExecutorsWithRegisterAsIs() {
    const partnersToOmit = [];
    this.confPost.getAllPartners().subscribe(async response => {
      let partners: any;
      partners = response;
      if (response) {
        for (let i = 0; i < partners.length; i++) {
          const partner = partners[i];
          if (!(partnersToOmit.includes(partner['partner']))) {
            if (partner['partner'] !== 'b2b') {
              for (let j = 0; j < partner['accounts'].length; j++) {
                const account = partner['accounts'][j];
                this.confPost.getAllExecutorsOfPartner(partner['partner'], account['account_id'], partner['partnerKey']).subscribe(async executorsResponse => {
                  if (executorsResponse) {
                    let executors: any;
                    executors = executorsResponse;
                    for (const executor of executors) {
                      if (executor && executor['executor_type'] === 'THIRDPARTY') {
                        await this.patchThirdPartyAPI(partner['partner'], account['account_id'], partner['partnerKey'], executor);
                      }
                    }
                  }
                });
              }
            }
          }
        }
      }
    });
  }

  configureGateway(service) {
    return new Promise((resolve, reject) => {
      this.kong.getServicesFromApiGatewayByNameOrId(service).subscribe(gatewayService => {
        if (gatewayService) {
          delete gatewayService['id'];
          this.kong.createServiceInGateway(gatewayService).then(serviceCreateResp => {
            this.kong.getPluginsForServiceInApiGateway(service).subscribe(async servicePlugins => {
              if (servicePlugins && servicePlugins.hasOwnProperty('data') && servicePlugins['data'] && servicePlugins['data'].length > 0) {
                let datadogFoundInService = false;
                for (let i = 0; i < servicePlugins['data'].length; i++) {
                  const tempPlugin = servicePlugins['data'][i];
                  let plugin: any;
                  if (tempPlugin['name'] !== 'datadog') {
                    plugin = {
                      name: tempPlugin['name'],
                      enabled: tempPlugin['enabled'],
                      config: tempPlugin['config']
                    };
                  } else {
                    datadogFoundInService = true;
                    plugin = {
                      name: tempPlugin['name'],
                      enabled: tempPlugin['enabled'],
                      config: {
                        host: '127.0.0.1',
                        port: 8125,
                        prefix: 'apiplatform'
                      }
                    };
                  }
                  await this.kong.createPluginForServiceInGateway({name: service}, plugin, {}).then(async servicePluginCreateResp => {
                    if (i === servicePlugins['data'].length - 1) {
                      if (datadogFoundInService === false) {
                        const datadog = {
                          name: 'datadog',
                          enabled: false,
                          config: {
                            host: '127.0.0.1',
                            port: 8125,
                            prefix: 'apiplatform'
                          }
                        };
                        await this.kong.createPluginForServiceInGateway({name: service}, datadog, {});
                      }
                      this.kong.getRoutesForAServiceFromApiGateway(service).subscribe(async routes => {
                        if (routes && routes.hasOwnProperty('data') && routes['data'] && routes['data'].length > 0) {
                          for (let j = 0; j < routes['data'].length; j++) {
                            const tempRoute1 = routes['data'][j];
                            const routepathdata = {
                              'name': tempRoute1['name'],
                              'protocols': tempRoute1['protocols'],
                              'hosts': tempRoute1['hosts'],
                              'paths': tempRoute1['paths'],
                              'methods': tempRoute1['methods'],
                              'created_at': tempRoute1['created_at'],
                              'updated_at': tempRoute1['updated_at']
                            };
                            await this.kong.createRouteInGateway({name: service}, routepathdata, {}).then(routeCreateResp => {
                              this.kong.getPluginsForRouteInApiGateway(routepathdata['name']).subscribe(async routePlugins => {
                                if (routePlugins && routePlugins.hasOwnProperty('data') && routePlugins['data'] && routePlugins['data'].length > 0) {
                                  for (let k = 0; k < routePlugins['data'].length; k++) {
                                    const tempPlugin1 = routePlugins['data'][k];
                                    let plugin1: any;
                                    let dataDogFoundInRoute = false;
                                    if (tempPlugin1['name'] !== 'datadog') {
                                      plugin1 = {
                                        name: tempPlugin1['name'],
                                        enabled: tempPlugin1['enabled'],
                                        config: tempPlugin1['config']
                                      };
                                    } else {
                                      dataDogFoundInRoute = true;
                                      plugin1 = {
                                        name: tempPlugin1['name'],
                                        enabled: tempPlugin1['enabled'],
                                        config: {
                                          host: '127.0.0.1',
                                          port: 8125,
                                          prefix: 'apiplatform'
                                        }
                                      };
                                    }
                                    await this.kong.createPluginForRouteInGateway({name: routepathdata['name']}, plugin1, {}).then(async routePluginCreateResp => {
                                      if (k === routePlugins['data'].length - 1) {
                                        if (dataDogFoundInRoute === false) {
                                          const datadog = {
                                            name: 'datadog',
                                            enabled: false,
                                            config: {
                                              host: '127.0.0.1',
                                              port: 8125,
                                              prefix: 'apiplatform'
                                            }
                                          };
                                          await this.kong.createPluginForRouteInGateway({name: routepathdata['name']}, datadog, {});
                                        }
                                      }
                                      if ((k === routePlugins['data'].length - 1) && (j === routes['data'].length - 1)) {
                                        resolve('success');
                                      }
                                    });
                                  }
                                } else {
                                  if (j === routes['data'].length - 1) {
                                    resolve('success');
                                  }
                                }
                              });
                            });
                          }
                        } else {
                          resolve('success');
                        }
                      });
                    }
                  });
                }
              } else {
                this.kong.getRoutesForAServiceFromApiGateway(service).subscribe(async routes => {
                  if (routes && routes.hasOwnProperty('data') && routes['data'] && routes['data'].length > 0) {
                    for (let j = 0; j < routes['data'].length; j++) {
                      const tempRoute1 = routes['data'][j];
                      const routepathdata = {
                        'name': tempRoute1['name'],
                        'protocols': tempRoute1['protocols'],
                        'hosts': tempRoute1['hosts'],
                        'paths': tempRoute1['paths'],
                        'methods': tempRoute1['methods'],
                        'created_at': tempRoute1['created_at'],
                        'updated_at': tempRoute1['updated_at']
                      };
                      await this.kong.createRouteInGateway({name: service}, routepathdata, {}).then(routeCreateResp => {
                        this.kong.getPluginsForRouteInApiGateway(routepathdata['name']).subscribe(async routePlugins => {
                          if (routePlugins && routePlugins.hasOwnProperty('data') && routePlugins['data'] && routePlugins['data'].length > 0) {
                            for (let k = 0; k < routePlugins['data'].length; k++) {
                              const tempPlugin1 = routePlugins['data'][k];
                              let plugin1: any;
                              let dataDogFoundInRoute = false;
                              if (tempPlugin1['name'] !== 'datadog') {
                                plugin1 = {
                                  name: tempPlugin1['name'],
                                  enabled: tempPlugin1['enabled'],
                                  config: tempPlugin1['config']
                                };
                              } else {
                                dataDogFoundInRoute = true;
                                plugin1 = {
                                  name: tempPlugin1['name'],
                                  enabled: tempPlugin1['enabled'],
                                  config: {
                                    host: '127.0.0.1',
                                    port: 8125,
                                    prefix: 'apiplatform'
                                  }
                                };
                              }
                              await this.kong.createPluginForRouteInGateway({name: routepathdata['name']}, plugin1, {}).then(async routePluginCreateResp => {
                                if (k === routePlugins['data'].length - 1) {
                                  if (dataDogFoundInRoute === false) {
                                    const datadog = {
                                      name: 'datadog',
                                      enabled: false,
                                      config: {
                                        host: '127.0.0.1',
                                        port: 8125,
                                        prefix: 'apiplatform'
                                      }
                                    };
                                    await this.kong.createPluginForRouteInGateway({name: routepathdata['name']}, datadog, {});
                                  }
                                }
                                if ((k === routePlugins['data'].length - 1) && (j === routes['data'].length - 1)) {
                                  resolve('success');
                                }
                              });
                            }
                          } else {
                            if (j === routes['data'].length - 1) {
                              resolve('success');
                            }
                          }
                        });
                      });
                    }
                  } else {
                    resolve('success');
                  }
                });
              }
            });
          }, error => {
            resolve('failed');
          });
        } else {
          resolve({isFound: 'false'});
        }
      }, error => {
        resolve({isFound: 'false'});
      });
    });
  }

  createDefaultGatewayConfigurations() {

    const partnersToOmit = ['dev-shanthan',"Apiplatform","confap","billing","commons","thedroid","EXPE","Sank","post10","sj","demo","personal","Bestdoc","canure","protoezy","dev","malarvikram","test15","billings","bobme","vikasssssh","stejas101","vikash","demoaccount","demoaccount2","linkzy","bestdoc","73arxiv",
      "demoaccount3","demoaccount5","prasanna","demoapi","cbilla","rajkumar","b2b","stejas999","access","hemanth","S","neelambika","suveechiam","hamsinims","covid19","grocury","excelonacad","dinx","rl","campaign","Datapattern","services","dash", 'pyudroi', 'srivi', 'salesdemo', 'templates', 'Green', 'legal', 'M', 'apsupport', 'legal', 'Bell', 'apiplatform1', 'FLIPKART',
      'devopsbees', 'neo', 'DevOpsInc', 'sconf', 'Mindtree', 'ConfApPartner', 'dummy', 'linxworks', 'vimobin', "ramanathan","BELL","WIPRO","CAPGEMINI","Microcloud","knirmalcs","VFI","AD2PRO","bell","TEST","WDC","wdc","ddroid","DD","CC","hellotars","product","alphabet","taking","takingtest","takingtest2","tmail","appleapi","pretty","sathish","testprasanna","test111",
      "uncap","demoaccount8","redd","identitygeek","yuvidammy","test","alexy","bigjimbo","thinkify","mbeedala","appsmith","admindevex","suveechi","iiipte","testdemo","Linkzy","facxo","bubble","clcg","Knightwatch","admin","anu","aptfrm","stejas1011","wtf","itsmevenkat",
      "ramyasainath","admin-prasanna","admin-sri","dev-sri","sri","undefined-sri","qa-sri","admin-samples","samples","saitest1-sri","saitest2-sri","saitest4-sri","testsai8-sri","admin-stejas","stejas","dev-stejas","saitest1-stejas","saitest-stejas","malarvikram1","admin-saitest32","saitest32","admin-hubspire","hubspire","admin-stagehub","stagehub","admin-saitej","saitej",
      "admin-testgi","testgi","admin-demotest1","demotest1","admin-jbissel","jbissel","admin-malartest2","admin-malartest3","malartest3","admin-hubspire2","hubspire2","admin-vince","vince","admin-vince123","vince123","admin-16pw27","admin-16pw27","admin-16pw27",
      "admin-16pw27","admin-16pw27","admin-16pw27","admin-16pw27","admin-16pw27","admin-16pw27","dev-16pw27","admin-testacc","admin-itsmp","dev-itsmp","admin-temptest","admin-malarvikram","admin-shashank152k","admin-services","admin-bashatest8","admin-bashatest9","test-bashatest8","test1-bashatest8","admin-bashatest10","admin-bashatest11","bashatest10","admin-bashatest12",
      "staging-bashatest12","bashatest12","test-bashatest12","admin-welcome","welcome","shashank152k","admin-guru","dev-guru","admin-ranjan","admin-Sai","admin-sai1","admin-sai3","admin-sai5","admin-sai6","admin-12345","admin-123456","dev-12345","qa-itsmp",
      "staging-itsmp","itsmp","admin-shashanknp12","admin-ua","dev-ua","admin-basha","admin-123456789123q","staging-basha","admin-linxmgt","dev-linxmgt","admin-ginie","admin-ginieremote","dev-ginieremote","ginieremote","admin-saikat","dev-saikat","admin-muthu","dev-muthu","admin-idntllabs","idntllabs","dev-idntllabs","qa-idntllabs","staging-idntllabs","admin-mixnercg",
      "dev-mixnercg","admin-dinx","admin-samarthademo","dev-samarthademo","admin-chandu","admin-samarthainfo","admin-samarthaabhi","admin-sam123","dev-chandu","dev-samarthaabhi","dev-samarthainfo","qa-samarthademo","staging-samarthademo","admin-adi123","qa-samarthaabhi","qa-adi123","qa-samarthainfo","admin-saitest","dev-saitest","qa-saitest","admin-excelonacad","dev-excelonacad",
      "test-malarvikram","admin-upekkha","admin-linkzy","qa-muthu","admin-adithyasuv","dev-adithyasuv","muthu","admin-gisela","dev-gisela","Madhu_Dev-muthu","mani_dev-muthu","admin-taskbench","dev-taskbench","admin-kishan","qa-kishan","admin-apptrackv1","dev-apptrackv1","admin-tech","dev-tech","admin-giniescience","dev-giniescience","admin-prashanth12","admin-shanthan","admin-kassu",
      "dev-kassu","admin-hari0101","hari0101","qa-prashanth12","qa-shanthan","staging-shanthan","shanthan","dev-Jason-muthu", "basha",
      "admin-saitest1","dev-saitest1","dev-virginia-muthu","admin-vtantral","dev-vtantral","admin-lcnc","dev-lcnc","qa-lcnc","dev-hari0101","admin-guru@lamico.co","PreProd-muthu","admin-iamtodd","dev-iamtodd","testenvdemo3-ha-hari0101","testenvdemo3-hari0101","testenvdemo6-hari0101","testenvdemo7-hari0101","testenvdemo8-hari0101","testenvdemo10-hari0101","testenvdemo11-hari0101",
      "testenvdemo12-hari0101","test5-malarvikram","dev-david-muthu","dev_Nanda-muthu","testenvdemo19-hari0101","devmalar-muthu","test6-malarvikram","DGTest-muthu","testenvdemo21-hari0101","admin-david_gulotta","dev-david_gulotta","PreprodA-muthu","admin-johnbelbute","admin-election","dev-election","dev-johnbelbute","dev-sam123","admin-gsam","admin-freshworkstest","RajaProd-muthu",
      "devVini-muthu","admin-samartha","dev-samartha","ad-kassu","devskaria-muthu","dev-linkzy","devbobby-muthu","Moondev-malarvikram","DEVMIKE-malarvikram","DEVMIKE1-malarvikram","devmike2-malarvikram","admin-vinothdev","dev-vinothdev","admin-servo","dev-servo","sandathadev-malarvikram","qa-sam123","devprithvik-muthu","automation-hari0101","anshuman-malarvikram","admin-ishwariya",
      "dev-ishwariya","admin-demotest","admin-samarthapramod","dev-samarthapramod","qa-samarthapramod","manimegalai-malarvikram","dev-ginie",
      "dev-demotest","admin-demotest2","dev-demotest2","admin-sandhata","dev-sandhata","admin-kinderpedia","dev-kinderpedia","testsuite-hari0101","andrew-malarvikram","admin-usertest","qa-usertest2","admin-rjdbuilders","admin-access","admin-b2b","admin-commons","qa-malarvikram","admin-medsec","dev-medsec","devjm-muthu","dev-access","admin-testprashanth","dev-testprash02","qa-testprash02"
      ,"testprash02","dev-testprash03","eoratech-malarvikram","admin-eoratech","dev-eoratech","admin-testcheck","dev-testcheck","admin-demosession","dev-demosession","testenv-hari0101","admin-testhari3","admin-tringappstest","dev-tringappstest","admin-pramodpk","qa-kassu","admin-gandhily","dev-gandhily","admin-testmv","dev-testmv","admin-satellitetest","dev-satellitetest","admin-madness",
      "dev-madness","admin-provisionllc","admin-midhun","dev-midhun","admin-automation10","dev-gsam","admin-gaha","dev-gaha","qa-gsam","test-gaha","qa-gaha","staging-gaha","example1-gsam"];

    this.confPost.getAllPartners().subscribe(async response => {
      let partners: any;
      partners = response;
      if (response) {
        for (let i = 0; i < partners.length; i++) {
          const partner = partners[i];
          if (!(partnersToOmit.includes(partner['partner'])) && partner.hasOwnProperty('accounts') && partner['accounts'] && partner['accounts'].length > 0 && partner['partnerKey']) {
            // if (partner['partner'] === 'dev-shanthan') {
            for (let j = 0; j < partner['accounts'].length; j++) {
              const account = partner['accounts'][j];
              if (account && account.hasOwnProperty('entities') && account['entities'] && account['entities'].length > 0) {
                for (let k = 0; k < account['entities'].length; k++) {
                  const entity = account['entities'][k];
                  await this.configureGateway(partner['partner'] + '-' + account['account_id'] + '-' + entity['entityname'] + '-' + entity['version']).then(async gatewayResult => {
                    if (j === partner['accounts'].length - 1 && k === account['entities'].length - 1) {
                      // await this.createDefaultGatewayConfigurationsForExecutors(partner);
                    }
                  });
                }
              } else {
                // await this.createDefaultGatewayConfigurationsForExecutors(partner);
              }
            }
            // }
          }
        }
      }
    });
  }

  createDefaultGatewayConfigurationsForExecutors(partner) {
    return new Promise((resolve, reject) => {
      for (let k = 0; k < partner['accounts'].length; k++) {
        const account = partner['accounts'][k];
        this.confPost.getAllExecutorsOfPartner(partner['partner'], account['account_id'], partner['partnerKey']).subscribe(async executorsResponse => {
          if (executorsResponse) {
            let executors: any;
            executors = executorsResponse;
            if (executors && executors.length > 0) {
              for (let l = 0; l < executors.length; l++) {
                const executor = executors[l];
                if (executor && executor['executor_type'] !== 'API') {
                  await this.configureGateway(partner['partner'] + '-' + account['account_id'] + '-' + executor['executor_name'] + '-' + executor['executor_version']).then(async gatewayResult => {
                    if (k === partner['accounts'].length - 1 && l === executors.length - 1) {
                      this.forCreated.push(partner['partner']);
                      localStorage.setItem('forCreated', JSON.stringify(this.forCreated));
                      resolve('success');
                    }
                  });
                } else {
                  if (k === partner['accounts'].length - 1 && l === executors.length - 1) {
                    this.forCreated.push(partner['partner']);
                    localStorage.setItem('forCreated', JSON.stringify(this.forCreated));
                    resolve('success');
                  }
                }
              }
            } else {
              this.forCreated.push(partner['partner']);
              localStorage.setItem('forCreated', JSON.stringify(this.forCreated));
              resolve('success');
            }
          } else {
            resolve('failed');
          }
        });
      }
    });
  }

  createKey(consumer, data) {
    return new Promise((resolve, reject) => {
      this.kong.provisionKeyAuthToConsumerInNewApiGatewayByNameOrId(consumer, data).subscribe(consResp => {
        resolve('success');
      }, error => {
        resolve('failed');
      });
    });
  }

  retainOldConsumerDetailsInNewKong(consumer) {
    return new Promise((resolve, reject) => {
      const consumerData = {
        'username': consumer['username'],
        'custom_id': consumer['custom_id'],
        'tags': consumer['tags'],
        'created_at': consumer['created_at']
      };
      const key = {
        value: ''
      };

      // this.kong.deleteConsumerFromNewApiGateway(consumer['username']).subscribe(resp => {
      //   resolve('success');
      // }, error => {
      // });

      this.kong.createConsumerInNewApiGateway(consumerData).subscribe(async cons => {
        this.kong.getKeyAuthForConsumerInApiGatewayByNameOrId(consumerData['username']).subscribe(keys => {
          const apiKeyData = keys;
          if (apiKeyData['data'] !== null && apiKeyData['data'] !== undefined && apiKeyData['data'].length !== 0) {
            for (let i = 0; i < apiKeyData['data'].length; i++) {
              if (apiKeyData['data'][i]) {
                this.createKey(consumer['username'], {key: apiKeyData['data'][i]['key']}).then(resp => {
                  if (i === apiKeyData['data'].length - 1) {
                    this.kong.getKongGatewayCredentialDetails('acls', consumerData['username']).subscribe(aclResp => {
                      const acls = aclResp;
                      if (acls['data'] !== null && acls['data'] !== undefined && acls['data'].length !== 0) {
                        for (let j = 0; j < acls['data'].length; j++) {
                          this.kong.postKongGatewayAPIkeyDetailsInNew(consumer['username'], {group: acls['data'][j]['group']}, 'acls').subscribe(aclPostResp => {
                            if (j === acls['data'].length - 1) {
                              this.kong.getKongGatewayCredentialDetails('basic-auth', consumerData['username']).subscribe(basicResp => {
                                const basicAuths = basicResp;
                                if (basicAuths['data'] !== null && basicAuths['data'] !== undefined && basicAuths['data'].length !== 0) {
                                  for (let k = 0; k < basicAuths['data'].length; k++) {
                                    this.kong.postKongGatewayAPIkeyDetailsInNew(consumer['username'], {username: basicAuths['data'][k]['username'], password: basicAuths['data'][k]['password']}, 'basic-auth').subscribe(basicPostResp => {
                                      if (k === basicAuths['data'].length - 1) {
                                        this.kong.getKongGatewayCredentialDetails('hmac-auth', consumerData['username']).subscribe(hmacResp => {
                                          const hmacAuths = hmacResp;
                                          if (hmacAuths['data'] !== null && hmacAuths['data'] !== undefined && hmacAuths['data'].length !== 0) {
                                            for (let l = 0; l < hmacAuths['data'].length; l++) {
                                              this.kong.postKongGatewayAPIkeyDetailsInNew(consumer['username'], {username: hmacAuths['data'][l]['username'], secret: hmacAuths['data'][l]['secret']}, 'hmac-auth').subscribe(hmacPostResp => {
                                                if (l === hmacAuths['data'].length - 1) {
                                                  resolve('success');
                                                }
                                              }, error => {
                                                resolve('failed');
                                              });
                                            }
                                          } else {
                                            resolve('failed');
                                          }
                                        }, error => {
                                          resolve('failed');
                                        });                                      }
                                    }, error => {
                                      resolve('failed');
                                    });
                                  }
                                } else {
                                  resolve('success');
                                }
                              }, error => {
                                resolve('failed');
                              });
                            }
                          }, error => {
                            resolve('failed');
                          });
                        }
                      } else {
                        resolve('success');
                      }
                    }, error => {
                      resolve('failed');
                    });
                  }
                });
              }
            }
          } else {
            resolve('success');
          }
        }, error => {
          resolve('failed');
        });
      }, error1 => {
        resolve('failed');
      });
    });
  }

  patchEntity(id, data) {
    return new Promise((resolve, reject) => {
      this.confPost.patchEntityData('services', 'services', 'v2', 'settings', id, data).subscribe(response => {
        resolve('success');
      }, error => {
        resolve('failed');
      });
    });
  }

  removeKeyAnonymousFromSettingsGatewayConfig() {
    let settingsResponse: any;
    this.confPost.getData('services', 'services', 'v2', 'settings', 'dbref=false').subscribe(async response => {
      if (response) {
        settingsResponse = response;
        for (const setting of settingsResponse) {
          // if (setting['partner'] === 'admin-kassu') {
          if (setting.hasOwnProperty('isEnabled')) {
            delete setting['isEnabled'];
          }
          for (const env of setting['environments']) {
              const gateway = env['services'].filter((object) => object.type === 'apigateway');
              if (gateway && gateway.length === 1) {
                if (Array.isArray(gateway[0]['configurations'][0]['gateway_configurations'])) {
                  for (const configuration of gateway[0]['configurations'][0]['gateway_configurations']) {
                    if (configuration && configuration['name'] === 'key-auth') {
                      configuration['tagline'] = 'Add Key Authentication (also referred to as an API key) to your APIs. Consumers then add their key either in a querystring parameter or a header to authenticate their requests';
                      configuration['config'] = [
                        {
                          'displayName': 'Key Names',
                          'parameter': 'key_names',
                          'type': 'array_string',
                          'value': 'apikey',
                          'isRequired': true,
                          'description': 'Describes an array of parameter names where the plugin will look for a key. The client must send the authentication key in one of those key names, and the plugin will try to read the credential from a header, request body, or query string parameter with the same name.\n' +
                              'Note: The key names may only contain [a-z], [A-Z], [0-9], [_] underscore, and [-] hyphen'
                        },
                        {
                          'displayName': 'Key In Body',
                          'parameter': 'key_in_body',
                          'type': 'boolean',
                          'value': false,
                          'isRequired': false,
                          'description': 'If enabled, the plugin reads the request body (if said request has one and its MIME type is supported) and tries to find the key in it. Supported MIME types: application/www-form-urlencoded, application/json, and multipart/form-data'
                        },
                        {
                          'displayName': 'Hide Credentials',
                          'parameter': 'hide_credentials',
                          'type': 'boolean',
                          'value': false,
                          'isRequired': false,
                          'description': 'An optional boolean value telling the plugin to show or hide the credential from the upstream service. If true, the plugin strips the credential from the request (i.e., the header, query string, or request body containing the key) before proxying it'
                        },
                        {
                          'displayName': 'Run On Preflight',
                          'parameter': 'run_on_preflight',
                          'type': 'boolean',
                          'value': true,
                          'isRequired': false,
                          'description': 'A boolean value that indicates whether the plugin should run (and try to authenticate) on OPTIONS preflight requests. If set to false, then OPTIONS requests are always allowed'
                        },
                        // {
                        //   'displayName': 'Anonymous',
                        //   'parameter': 'anonymous',
                        //   'type': 'string',
                        //   'value': '',
                        //     'isRequired': false,
                        //     'description': 'An optional string (Consumer UUID) value to use as an anonymous Consumer if authentication fails. If empty (default), the request will fail with an authentication failure 4xx. Note that this value must refer to the Consumer id attribute that is internal to Kong, and not its custom_id'
                        // },
                        {
                          'displayName': 'Key In Header',
                          'parameter': 'key_in_header',
                          'type': 'boolean',
                          'value': true,
                          'isRequired': false,
                          'description': 'If enabled (default), the plugin reads the request header and tries to find the key in it'
                        },
                        {
                          'displayName': 'Key In Query',
                          'parameter': 'key_in_query',
                          'type': 'boolean',
                          'value': true,
                          'isRequired': false,
                          'description': 'If enabled (default), the plugin reads the query parameter in the request and tries to find the key in it'
                        },
                      ];
                    } else if (configuration && configuration['name'] === 'cors') {
                      configuration['tagline'] = 'Allow developers to make requests from the browser. Easily add cross-origin resource sharing (CORS) to a Service and a Route by enabling this plugin';
                      configuration['config'] = [
                        // {
                        //   'parameter': 'consumerID',
                        //   'type': 'string',
                        //   'value': '',
                        //   'description': 'The CONSUMER ID that this plugin configuration will target. This value can only be used if authentication has been enabled so that the system can identify the user making the request. If left blank, the plugin will be applied to all consumers.'
                        // },
                        {
                          'displayName': 'Origins',
                          'parameter': 'origins',
                          'type': 'array_string',
                          'value': '*',
                          'isRequired': false,
                          'description': 'List of allowed domains for the Access-Control-Allow-Origin header. If you want to allow all origins, add * as a single value to this configuration field. The accepted values can either be flat strings or PCRE regexes'
                        },
                        {
                          'displayName': 'Headers',
                          'parameter': 'headers',
                          'type': 'array_string',
                          'value': null,
                          'isRequired': false,
                          'description': 'Tip: Comma separated values for the Access-Control-Allow-Headers header, expects a comma delimited string (e.g. Origin, Authorization).'
                        },
                        {
                          'displayName': 'Exposed Headers',
                          'parameter': 'exposed_headers',
                          'type': 'array_string',
                          'value': null,
                          'isRequired': false,
                          'description': 'Tip: Comma separated values for the Access-Control-Expose-Headers header, expects a comma delimited string (e.g. Origin, Authorization). If not specified, no custom headers are exposed.'
                        },
                        {
                          'displayName': 'Methods',
                          'parameter': 'methods',
                          'type': 'array_string',
                          'value': null,
                          'isRequired': false,
                          'description': 'Value for the Access-Control-Allow-Methods header. Available options include GET, HEAD, PUT, PATCH, POST, DELETE, OPTIONS, TRACE, CONNECT. By default, all options are allowed'
                        },
                        {
                          'displayName': 'Max Age',
                          'parameter': 'max_age',
                          'type': 'number',
                          'value': 300,
                          'isRequired': false,
                          'description': 'Indicates how long the results of the preflight request can be cached, in seconds'
                        },
                        {
                          'displayName': 'Credentials',
                          'parameter': 'credentials',
                          'type': 'boolean',
                          'value': false,
                          'isRequired': true,
                          'description': 'Flag to determine whether the Access-Control-Allow-Credentials header should be sent with true as the value'
                        },
                        {
                          'displayName': 'Preflight Continue',
                          'parameter': 'preflight_continue',
                          'type': 'boolean',
                          'value': false,
                          'isRequired': true,
                          'description': 'A boolean value that instructs the plugin to proxy the OPTIONS preflight request to the Upstream service'
                        }
                      ];
                    } else if (configuration && configuration['name'] === 'ip-restriction') {
                      configuration['tagline'] = 'Restrict access to a Service or a Route by either allowing or denying IP addresses. Single IPs, multiple IPs or ranges in CIDR notation like 10.10.10.0/24 can be used. The plugin supports IPv4 and IPv6 addresses';
                      configuration['config'] = [
                        // {
                        //   'parameter': 'consumerID',
                        //   'type': 'string',
                        //   'value': '',
                        //   'description': 'The CONSUMER ID that this plugin configuration will target. This value can only be used if authentication has been enabled so that the system can identify the user making the request. If left blank, the plugin will be applied to all consumers.'
                        // },
                        {
                          'displayName': 'Allow',
                          'parameter': 'allow',
                          'type': 'array_string',
                          'value': '127.0.0.1',
                          'description': 'Tip: Comma separated list of IPs or CIDR ranges to whitelist. At least one between whitelist or blacklist must be specified.'
                        },
                        {
                          'displayName': 'Deny',
                          'parameter': 'deny',
                          'type': 'array_string',
                          'value': null,
                          'description': 'Tip: Comma separated list of IPs or CIDR ranges to blacklist. At least one between whitelist or blacklist must be specified.'
                        }
                      ];
                    } else if (configuration && configuration['name'] === 'rate-limiting') {
                      configuration['tagline'] = 'Rate limit how many HTTP requests a developer can make in a given period of seconds, minutes, hours, days, months or years. If the API has no authentication layer, the Client IP address will be used, otherwise the Consumer will be used if an authentication plugin has been configured';
                      configuration['config'] = [
                        {
                          'displayName': 'Second',
                          'parameter': 'second',
                          'type': 'number',
                          'value': null,
                          'isRequired': false,
                          'description': 'The number of HTTP requests that can be made per second'
                        },
                        {
                          'displayName': 'Minute',
                          'parameter': 'minute',
                          'type': 'number',
                          'value': 5,
                          'isRequired': false,
                          'description': 'The number of HTTP requests that can be made per minute'
                        },
                        {
                          'displayName': 'Hour',
                          'parameter': 'hour',
                          'type': 'number',
                          'value': null,
                          'isRequired': false,
                          'description': 'The number of HTTP requests that can be made per hour'
                        },
                        {
                          'displayName': 'Day',
                          'parameter': 'day',
                          'type': 'number',
                          'value': null,
                          'isRequired': false,
                          'description': 'The number of HTTP requests that can be made per day'
                        },
                        {
                          'displayName': 'Month',
                          'parameter': 'month',
                          'type': 'number',
                          'value': null,
                          'isRequired': false,
                          'description': 'The number of HTTP requests that can be made per month'
                        },
                        {
                          'displayName': 'Year',
                          'parameter': 'year',
                          'type': 'number',
                          'value': null,
                          'isRequired': false,
                          'description': 'The number of HTTP requests that can be made per year'
                        },
                        {
                          'displayName': 'Limit By',
                          'parameter': 'limit_by',
                          'type': 'string',
                          'value': 'consumer',
                          'isRequired': false,
                          'description': 'The entity that will be used when aggregating the limits: consumer, credential, ip, service, header, path. If the value for the entity chosen to aggregate the limit cannot be determined, the system will always fallback to ip. If value service is chosen, the service_id configuration must be provided. If value header is chosen, the header_name configuration must be provided. If value path is chosen, the path configuration must be provided'
                        },
                        {
                          'displayName': 'Policy',
                          'parameter': 'policy',
                          'type': 'string',
                          'value': 'local',
                          'isRequired': false,
                          'description': 'In DB-less and hybrid modes, the cluster config policy is not supported. For DB-less mode, use one of redis or local; for hybrid mode, use redis, or local for data planes only.\n' +
                              '\n' +
                              'In Konnect Cloud, the default policy is redis'
                        },
                        {
                          'displayName': 'Fault Tolerant',
                          'parameter': 'fault_tolerant',
                          'type': 'boolean',
                          'value': true,
                          'isRequired': false,
                          'description': 'A boolean value that determines if the requests should be proxied even if Kong has troubles connecting a third-party datastore. If true, requests will be proxied anyway, effectively disabling the rate-limiting function until the datastore is working again. If false, then the clients will see 500 errors'
                        },
                        {
                          'displayName': 'Hide Client Headers',
                          'parameter': 'hide_client_headers',
                          'type': 'boolean',
                          'value': false,
                          'isRequired': false,
                          'description': 'Optionally hide informative response headers'
                        },
                        {
                          'displayName': 'Redis Host',
                          'parameter': 'redis_host',
                          'type': 'string',
                          'value': 'localhost',
                          'isRequired': false,
                          'description': 'When using the redis policy, this property specifies the address to the Redis server'
                        },
                        {
                          'displayName': 'Redis Password',
                          'parameter': 'redis_password',
                          'type': 'string',
                          'value': '',
                          'isRequired': false,
                          'description': 'When using the redis policy, this property specifies the password to connect to the Redis server'
                        },
                        {
                          'displayName': 'Redis Port',
                          'parameter': 'redis_port',
                          'type': 'number',
                          'value': 6379,
                          'isRequired': false,
                          'description': 'When using the redis policy, this property specifies the port of the Redis server. By default is 6379'
                        },
                        {
                          'displayName': 'Redis Timeout',
                          'parameter': 'redis_timeout',
                          'type': 'number',
                          'value': 2000,
                          'isRequired': false,
                          'description': 'When using the redis policy, this property specifies the timeout in milliseconds of any command submitted to the Redis server'
                        },
                        {
                          'displayName': 'Redis Database',
                          'parameter': 'redis_database',
                          'type': 'number',
                          'value': 0,
                          'isRequired': false,
                          'description': 'When using the redis policy, this property specifies the Redis database to use'
                        },
                        // {
                        //   'displayName': 'Header Name',
                        //   'parameter': 'header_name',
                        //   'type': 'string',
                        //   'value': '',
                        //     'isRequired': false,
                        //     'description': 'Header name to be used if limit_by is set to header'
                        // },
                        // {
                        //   'displayName': 'Path',
                        //   'parameter': 'path',
                        //   'type': 'string',
                        //   'value': '',
                        //   'isRequired': false,
                        //   'description': 'Path to be used if limit_by is set to path'
                        // },
                      ];
                    }
                  }
                }
              }
            }
            // await this.patchEntity(setting['id'], setting);
          // }
        }
      }
    });
  }

  patchPlugin(plugin) {
    return new Promise((resolve, reject) => {
      this.kong.patchPluginInApiGateway(plugin['id'], plugin).subscribe(resp => {
        resolve('success');
      }, error => {
        resolve('failed');
      });
    });
  }

  patchDatadog(service) {
    return new Promise((resolve, reject) => {
      this.kong.getPluginsForServiceInApiGateway(service).subscribe(async servicePlugins => {
        if (servicePlugins && servicePlugins.hasOwnProperty('data') && servicePlugins['data'] && servicePlugins['data'].length > 0) {
          let datadogFoundInService = false;
          let serviceDatadogPlugin: any;
          let plugin: any;
          for (let i = 0; i < servicePlugins['data'].length; i++) {
            if (servicePlugins['data'][i]) {
              const tempPlugin = servicePlugins['data'][i];
              if (tempPlugin['name'] === 'datadog') {
                datadogFoundInService = true;
                serviceDatadogPlugin = tempPlugin;
              }
            }
          }
          if (datadogFoundInService === false) {
            plugin = {
              name: 'datadog',
              enabled: true,
              config: {
                host: '127.0.0.1',
                port: 8125,
                prefix: 'apiplatform'
              }
            };
            await this.kong.createPluginForServiceInGateway({name: service}, plugin, {}).then(async servicePluginCreateResp => {});
          } else {
            if (serviceDatadogPlugin) {
              if (serviceDatadogPlugin['enabled'] === false) {
                serviceDatadogPlugin['enabled'] = true;
                await this.patchPlugin(serviceDatadogPlugin);
              }
            }
          }
          this.kong.getRoutesForAServiceFromApiGateway(service).subscribe(async routes => {
            if (routes && routes.hasOwnProperty('data') && routes['data'] && routes['data'].length > 0) {
              for (let j = 0; j < routes['data'].length; j++) {
                const tempRoute1 = routes['data'][j];
                this.kong.getPluginsForRouteInApiGateway(tempRoute1['name']).subscribe(async routePlugins => {
                  if (routePlugins && routePlugins.hasOwnProperty('data') && routePlugins['data'] && routePlugins['data'].length > 0) {
                    let dataDogFoundInRoute = false;
                    let routeDatadogPlugin: any;
                    let plugin1: any;
                    for (let k = 0; k < routePlugins['data'].length; k++) {
                      const tempPlugin1 = routePlugins['data'][k];
                      if (tempPlugin1['name'] === 'datadog') {
                        dataDogFoundInRoute = true;
                        routeDatadogPlugin = tempPlugin1;
                      }
                    }
                    if (dataDogFoundInRoute === false) {
                      plugin1 = {
                        name: 'datadog',
                        enabled: true,
                        config: {
                          host: '127.0.0.1',
                          port: 8125,
                          prefix: 'apiplatform'
                        }
                      };
                      await this.kong.createPluginForRouteInGateway({name: tempRoute1['name']}, plugin1, {}).then(async routePluginCreateResp => {
                        if ((j === routes['data'].length - 1)) {
                          resolve('success');
                        }
                      });
                    } else {
                      if (routeDatadogPlugin) {
                        if (routeDatadogPlugin['enabled'] === false) {
                          routeDatadogPlugin['enabled'] = true;
                          await this.patchPlugin(routeDatadogPlugin);
                          if ((j === routes['data'].length - 1)) {
                            resolve('success');
                          }
                        } else {
                          if ((j === routes['data'].length - 1)) {
                            resolve('success');
                          }
                        }
                      }
                    }
                  } else {
                    if (j === routes['data'].length - 1) {
                      resolve('success');
                    }
                  }
                });
              }
            } else {
              resolve('success');
            }
          });
        } else {
          this.kong.getRoutesForAServiceFromApiGateway(service).subscribe(async routes => {
            if (routes && routes.hasOwnProperty('data') && routes['data'] && routes['data'].length > 0) {
              for (let j = 0; j < routes['data'].length; j++) {
                const tempRoute1 = routes['data'][j];
                this.kong.getPluginsForRouteInApiGateway(tempRoute1['name']).subscribe(async routePlugins => {
                  if (routePlugins && routePlugins.hasOwnProperty('data') && routePlugins['data'] && routePlugins['data'].length > 0) {
                    let dataDogFoundInRoute = false;
                    let routeDatadogPlugin: any;
                    let plugin1: any;
                    for (let k = 0; k < routePlugins['data'].length; k++) {
                      const tempPlugin1 = routePlugins['data'][k];
                      if (tempPlugin1['name'] === 'datadog') {
                        dataDogFoundInRoute = true;
                        routeDatadogPlugin = tempPlugin1;
                      }
                    }
                    if (dataDogFoundInRoute === false) {
                      plugin1 = {
                        name: 'datadog',
                        enabled: true,
                        config: {
                          host: '127.0.0.1',
                          port: 8125,
                          prefix: 'apiplatform'
                        }
                      };
                      await this.kong.createPluginForRouteInGateway({name: tempRoute1['name']}, plugin1, {}).then(async routePluginCreateResp => {
                        if ((j === routes['data'].length - 1)) {
                          resolve('success');
                        }
                      });
                    } else {
                      if (routeDatadogPlugin) {
                        if (routeDatadogPlugin['enabled'] === false) {
                          routeDatadogPlugin['enabled'] = true;
                          await this.patchPlugin(routeDatadogPlugin);
                          if ((j === routes['data'].length - 1)) {
                            resolve('success');
                          }
                        } else {
                          if ((j === routes['data'].length - 1)) {
                            resolve('success');
                          }
                        }
                      }
                    }
                  } else {
                    if (j === routes['data'].length - 1) {
                      resolve('success');
                    }
                  }
                });
              }
            } else {
              resolve('success');
            }
          });
        }
      });
    });
  }

  enableDatadogInExistingAPIs(partner, account, name, version) {
    return new Promise((resolve, reject) => {
      this.kong.getServicesFromApiGatewayByNameOrId(partner + '-' + account + '-' + name + '-' + version).subscribe(async gatewayService => {
        if (gatewayService) {
          await this.patchDatadog(partner + '-' + account + '-' + name + '-' + version).then(resp => {
            resolve('success');
          });
        } else {
          resolve('failed');
        }
      }, error => {
        if (error.status === 404) {
          this.kong.getServicesFromApiGatewayByNameOrId(partner + '-' + account + '-' + name).subscribe(async gatewayService1 => {
            if (gatewayService1) {
              await this.patchDatadog(partner + '-' + account + '-' + name).then(resp => {
                resolve('success');
              });
            } else {
              resolve('failed');
            }
          }, error => {
            resolve('failed');
          });
        } else {
          resolve('failed');
        }
      });
    });
  }

  invokeEnableDatadogForExistingAPIs() {
    const partnersToOmit = ["malarvikram","malarvikram","b2b","dev-shanthan", "shanthan", "linkzy", "excelonacad", "biogreenmart", "services", "pyudroi","srivi","Apiplatform","salesdemo","ramanathan","templates","Green","legal","M","BELL","apsupport","Bell","WIPRO","apiplatform1","FLIPKART","CAPGEMINI","confap","devopsbees","neo","DevOpsInc","DevOpsInc","sconf","Mindtree",
      "ConfApPartner","billing","commons","Microcloud","knirmalcs","VFI","AD2PRO","vimobin","bell","thedroid","EXPE","Sank","post10","sj","TEST","WDC","wdc","ddroid","demo","DD","CC","personal","Bestdoc","canure","protoezy","dev","hellotars","product","alphabet","taking","takingtest","takingtest2","tmail","appleapi","pretty","sathish","testprasanna","test15","billings","bobme","vikasssssh","stejas101","test111",
      "vikash","demoaccount","demoaccount2","bestdoc","uncap","73arxiv","demoaccount3","demoaccount5","demoaccount8","prasanna","demoapi","cbilla","redd","identitygeek","yuvidammy","rajkumar","test","stejas999","alexy","bigjimbo","thinkify","mbeedala","appsmith","admindevex","suveechi","access","hemanth","iiipte","S","neelambika","suveechiam","hamsinims","testdemo","covid19","Linkzy","facxo","bubble","grocury","clcg",
      "dinx","Knightwatch","rl","campaign","admin","Datapattern","dummy","linxworks","anu","aptfrm","dash","stejas1011","wtf","itsmevenkat","ramyasainath","admin-prasanna","dev-sri","undefined-sri","qa-sri","samples","saitest1-sri","saitest2-sri","saitest4-sri","testsai8-sri","admin-stejas","stejas","dev-stejas","saitest1-stejas","saitest-stejas","malarvikram1","admin-saitest32","saitest32","admin-hubspire","hubspire",
      "admin-stagehub","stagehub","admin-saitej","saitej","admin-testgi","testgi","admin-demotest1","demotest1","admin-jbissel","jbissel","admin-malartest2","admin-malartest3","malartest3","admin-hubspire2","hubspire2","admin-vince","vince","admin-vince123","vince123","admin-16pw27","admin-16pw27","admin-16pw27","admin-16pw27","admin-16pw27","admin-16pw27","admin-16pw27","admin-16pw27","admin-16pw27","dev-16pw27",
      "admin-testacc","admin-itsmp","dev-itsmp","admin-temptest","admin-malarvikram","admin-shashank152k","admin-services","admin-bashatest8","admin-bashatest9","test-bashatest8","test1-bashatest8","admin-bashatest10","admin-bashatest11","bashatest10","admin-bashatest12","staging-bashatest12","bashatest12","test-bashatest12","admin-welcome","welcome","shashank152k","admin-guru","dev-guru","admin-ranjan","admin-Sai",
      "admin-sai1","admin-sai3","admin-sai5","admin-sai6","admin-123456","qa-itsmp","staging-itsmp","itsmp","admin-shashanknp12","admin-ua","dev-ua","admin-basha","basha","staging-basha","admin-linxmgt","dev-linxmgt","admin-ginie","dev-ginie","admin-ginieremote","dev-ginieremote","ginieremote","admin-saikat","dev-saikat","admin-muthu","dev-muthu","admin-idntllabs","idntllabs","dev-idntllabs","qa-idntllabs",
      "staging-idntllabs","admin-mixnercg","dev-mixnercg","admin-samarthademo","dev-samarthademo","admin-samarthainfo","admin-samarthaabhi","admin-sam123","dev-samarthaabhi","dev-samarthainfo","qa-samarthademo","staging-samarthademo","qa-samarthaabhi","qa-samarthainfo","admin-saitest","dev-saitest","qa-saitest","admin-excelonacad","dev-excelonacad", "test-malarvikram","admin-upekkha","admin-linkzy","qa-muthu",
      "muthu","admin-gisela","dev-gisela","Madhu_Dev-muthu","mani_dev-muthu","admin-taskbench","dev-taskbench","admin-kishan","qa-kishan","admin-apptrackv1","dev-apptrackv1","admin-tech","dev-tech","admin-giniescience","dev-giniescience","admin-shanthan","admin-kassu","admin-hari0101","hari0101","dev-Jason-muthu","admin-saitest1","dev-saitest1","dev-virginia-muthu","admin-vtantral","dev-vtantral","admin-lcnc",
      "dev-lcnc","qa-lcnc","admin-guru@lamico.co","PreProd-muthu","admin-iamtodd","dev-iamtodd","testenvdemo3-ha-hari0101","testenvdemo3-hari0101","testenvdemo6-hari0101","testenvdemo7-hari0101","testenvdemo8-hari0101","testenvdemo10-hari0101","testenvdemo11-hari0101","dev-david-muthu","dev_Nanda-muthu","testenvdemo19-hari0101","devmalar-muthu","DGTest-muthu","testenvdemo21-hari0101","admin-david_gulotta",
      "dev-david_gulotta","PreprodA-muthu","admin-johnbelbute","admin-election","dev-election","dev-johnbelbute","dev-sam123","admin-gsam","admin-freshworkstest","RajaProd-muthu","devVini-muthu","admin-samartha","dev-samartha","devskaria-muthu","dev-linkzy","devbobby-muthu","Moondev-malarvikram","devmike2-malarvikram","admin-vinothdev","dev-vinothdev","admin-servo","dev-servo","sandathadev-malarvikram",
      "qa-sam123","devprithvik-muthu","automation-hari0101","anshuman-malarvikram","admin-ishwariya","dev-ishwariya","admin-demotest","admin-samarthapramod","dev-samarthapramod","qa-samarthapramod","manimegalai-malarvikram","dev-demotest","admin-demotest2","dev-demotest2","admin-sandhata","dev-sandhata","admin-kinderpedia","dev-kinderpedia","testsuite-hari0101","andrew-malarvikram","admin-usertest","qa-usertest2",
      "admin-rjdbuilders","admin-access","admin-b2b","admin-commons","admin-medsec","dev-medsec","devjm-muthu","dev-access","admin-testprashanth","dev-testprash02","qa-testprash02","testprash02","dev-testprash03","eoratech-malarvikram","admin-eoratech","dev-eoratech","admin-demosession","dev-demosession","testenv-hari0101","admin-testhari3","admin-tringappstest","dev-tringappstest","admin-pramodpk","admin-gandhily",
      "dev-gandhily","admin-testmv","dev-testmv","admin-satellitetest","dev-satellitetest","admin-madness","dev-madness","admin-provisionllc","admin-midhun","dev-midhun","admin-automation10","dev-gsam","admin-gaha","dev-gaha","qa-gsam","test-gaha","qa-gaha","staging-gaha","example1-gsam","admin-samples","admin-campaign","admin-vasanth","dev-vasanth","demo-hari0101","dev-dummysa","admin-dummysa1","dev-dummysa1","admin-dummysa"
      ,"admin-dummysa2","dev-dummysa2","dev1-shanthan","admin-biogreenmart","test-shanthan","admin-monitoring","monitoring","testdemo-shanthan","admin-ramkumar","dev-ramkumar","demo-shanthan","demotest-shanthan","admin-grabatech","admin-tvh","dev-tvh","dev2-shanthan","qa-shanthan","staging-shanthan","dev3-shanthan","admin-trialtnbt","dev-trialtnbt","dev-services","qa-services","admin-amigo","dev-amigo","qa-amigo","staging-amigo",
      "amigo","dev-malarvikram","admin-kvramkumar","dev-kvramkumar","admin-test99","dev-test99","qa-test99","admin-billings"];

    this.confPost.getAllPartners().subscribe(async response => {
      let partners: any;
      partners = response;
      if (response) {
        for (let i = 0; i < partners.length; i++) {
          const partner = partners[i];
          if (!(partnersToOmit.includes(partner['partner'])) && partner.hasOwnProperty('accounts') && partner['accounts'] && partner['accounts'].length > 0 && partner['partnerKey']) {
            // if (partner['partner'] === 'services') {
              for (let j = 0; j < partner['accounts'].length; j++) {
                const account = partner['accounts'][j];
                if (account && account.hasOwnProperty('entities') && account['entities'] && account['entities'].length > 0) {
                  for (let k = 0; k < account['entities'].length; k++) {
                    const entity = account['entities'][k];
                    await this.enableDatadogInExistingAPIs(partner['partner'], account['account_id'], entity['entityname'], entity['version']).then(async gatewayResult => {
                      if (j === partner['accounts'].length - 1 && k === account['entities'].length - 1) {
                        await this.patchDatadogConfigurationsForExecutors(partner);
                      }
                    });
                  }
                } else {
                  await this.patchDatadogConfigurationsForExecutors(partner);
                }
              }
            // }
          }
        }
      }
    });
  }

  patchDatadogConfigurationsForExecutors(partner) {
    return new Promise((resolve, reject) => {
      for (let k = 0; k < partner['accounts'].length; k++) {
        const account = partner['accounts'][k];
        this.confPost.getAllExecutorsOfPartner(partner['partner'], account['account_id'], partner['partnerKey']).subscribe(async executorsResponse => {
          if (executorsResponse) {
            let executors: any;
            executors = executorsResponse;
            if (executors && executors.length > 0) {
              for (let l = 0; l < executors.length; l++) {
                const executor = executors[l];
                if (executor && executor['executor_type'] !== 'API') {
                  await this.enableDatadogInExistingAPIs(partner['partner'], account['account_id'], executor['executor_name'], executor['executor_version']).then(async gatewayResult => {
                    if (k === partner['accounts'].length - 1 && l === executors.length - 1) {
                      this.forCreated.push(partner['partner']);
                      localStorage.setItem('forCreated', JSON.stringify(this.forCreated));
                      resolve('success');
                    }
                  });
                } else {
                  if (k === partner['accounts'].length - 1 && l === executors.length - 1) {
                    this.forCreated.push(partner['partner']);
                    localStorage.setItem('forCreated', JSON.stringify(this.forCreated));
                    resolve('success');
                  }
                }
              }
            } else {
              this.forCreated.push(partner['partner']);
              localStorage.setItem('forCreated', JSON.stringify(this.forCreated));
              resolve('success');
            }
          } else {
            resolve('failed');
          }
        });
      }
    });
  }

  patchSettingsData(data) {
    return new Promise((resolve, reject) => {
      let temp = data['partner'].split('-');
      const payload = {
        partner_name: temp[temp.length - 1],
        account_name: temp[temp.length - 1],
        environment_type: '',
        environments: []
      };
      if (temp.length === 1) {
        payload.environment_type = 'prod'
      } else {
        payload.environment_type = temp[0];
      }

      for (const env of data['environments']) {
        if (env) {
          let temp1 = env['name'].split('-');
          env['partner_name'] = temp1[temp1.length - 1];
          env['account_name'] = temp1[temp1.length - 1];
        }
      }

      payload['environments'] = data['environments'];

      this.confPost.patchEntityData('services', 'services', 'v2', 'settings', data['id'], payload).subscribe(res => {
        resolve('success');
      }, error => {
        reject('failed');
      })
    })
  }

  patchKeysInSettings() {
    let resp: any;
    this._service.getItems('v2', 'services', 'services', 'settings', false).subscribe(async response => {
      resp = response;
      for (const data of resp) {
        if (data) {
          await this.patchSettingsData(data);
        }
      }
    });
  }

  patchPOSTinOPTIONSRoute() {
    const partnersToOmit = ['dev-shanthan', 'dev-sandhata'];

    this.confPost.getAllPartners().subscribe(async response => {
      let partners: any;
      partners = response;
      if (response) {
        for (let i = 0; i < partners.length; i++) {
          const partner = partners[i];
          if (!(partnersToOmit.includes(partner['partner'])) && partner.hasOwnProperty('accounts') && partner['accounts'] && partner['accounts'].length > 0 && partner['partnerKey']) {
            if (partner['partner'] === 'dev-sandhata' || partner['partner'] === 'sandhata') {
            for (let j = 0; j < partner['accounts'].length; j++) {
              const account = partner['accounts'][j];
              if (account && account.hasOwnProperty('entities') && account['entities'] && account['entities'].length > 0) {
                for (let k = 0; k < account['entities'].length; k++) {
                  const entity = account['entities'][k];
                  await this.enablePatchInExistingAPIs(partner['partner'], account['account_id'], entity['entityname'], entity['version']).then(async gatewayResult => {
                    if (j === partner['accounts'].length - 1 && k === account['entities'].length - 1) {
                      await this.patchPOSTinOPTIONSForExecutors(partner);
                    }
                  });
                }
              } else {
                await this.patchPOSTinOPTIONSForExecutors(partner);
              }
            }
            }
          }
        }
      }
    });
  }

  patchPOSTinOPTIONSForExecutors(partner) {
    return new Promise((resolve, reject) => {
      for (let k = 0; k < partner['accounts'].length; k++) {
        const account = partner['accounts'][k];
        this.confPost.getAllExecutorsOfPartner(partner['partner'], account['account_id'], partner['partnerKey']).subscribe(async executorsResponse => {
          if (executorsResponse) {
            let executors: any;
            executors = executorsResponse;
            if (executors && executors.length > 0) {
              for (let l = 0; l < executors.length; l++) {
                const executor = executors[l];
                if (executor && executor['executor_type'] !== 'API') {
                  await this.enablePatchInExistingAPIs(partner['partner'], account['account_id'], executor['executor_name'], executor['executor_version']).then(async gatewayResult => {
                    if (k === partner['accounts'].length - 1 && l === executors.length - 1) {
                      this.forCreated.push(partner['partner']);
                      localStorage.setItem('forCreated', JSON.stringify(this.forCreated));
                      resolve('success');
                    }
                  });
                } else {
                  if (k === partner['accounts'].length - 1 && l === executors.length - 1) {
                    this.forCreated.push(partner['partner']);
                    localStorage.setItem('forCreated', JSON.stringify(this.forCreated));
                    resolve('success');
                  }
                }
              }
            } else {
              this.forCreated.push(partner['partner']);
              localStorage.setItem('forCreated', JSON.stringify(this.forCreated));
              resolve('success');
            }
          } else {
            resolve('failed');
          }
        });
      }
    });
  }

  enablePatchInExistingAPIs(partner, account, name, version) {
    return new Promise((resolve, reject) => {
      this.kong.getServicesFromApiGatewayByNameOrId(partner + '-' + account + '-' + name + '-' + version).subscribe(async gatewayService => {
        if (gatewayService) {
          await this.patchPOSTinOPTIONS(partner, account, name, version, partner + '-' + account + '-' + name + '-' + version).then(resp => {
            resolve('success');
          });
        } else {
          resolve('failed');
        }
      }, error => {
        if (error.status === 404) {
          this.kong.getServicesFromApiGatewayByNameOrId(partner + '-' + account + '-' + name).subscribe(async gatewayService1 => {
            if (gatewayService1) {
              await this.patchPOSTinOPTIONS(partner, account, name, version, partner + '-' + account + '-' + name).then(resp => {
                resolve('success');
              });
            } else {
              resolve('failed');
            }
          }, error => {
            resolve('failed');
          });
        } else {
          resolve('failed');
        }
      });
    });
  }

  patchPOSTinOPTIONS(partner, account, name, version, service) {
    return new Promise((resolve, reject) => {



      this.kong.getRouteFromApiGatewayByNameOrId(partner + '-' + account + '-' + name + '-' + version + '-' + 'POST').subscribe(resp => {
        resolve('success');
      }, error => {
        if (error.status === 404) {
          this.kong.getRouteFromApiGatewayByNameOrId(partner + '-' + account + '-' + name + '-' + version + '-' + 'OPTIONS').subscribe(response => {
            if (response) {
              this.kong.patchRouteInApiGateway(response['id'], {methods: ['OPTIONS', 'POST']}).subscribe(resp => {
                resolve('success');
              }, error => {
                resolve('failed');
              });
            } else {
              resolve('failed');
            }
          }, error => {
            resolve('failed');
          });
        } else {
          resolve('failed');
        }
      });
    });
  }

  createDefaultDocumentationPagesForExistingPartner() {
    const partnersToOmit = [];
    this.forCreated = [];

    this.confPost.getAllPartners().subscribe(async response => {
      let partners: any;
      partners = response;
      if (response) {
        for (let i = 0; i < partners.length; i++) {
          const partner = partners[i];
          const temp = partner['partner'].split('-');
          if (temp[0] !== 'admin') {
            if (!(partnersToOmit.includes(partner['partner'])) && partner.hasOwnProperty('accounts') && partner['accounts'] && partner['accounts'].length > 0 && partner['partnerKey']) {
              if (partner['partner'] === 'test-malarvikram' || partner['partner'] === 'dev-shanthan') {
                await this.createDefaultDocumentationPages(partner['partner']);
                this.forCreated.push(partner['partner']);
                localStorage.setItem('forCreated', JSON.stringify(this.forCreated));
              }
            }
          }
        }
      }
    });
  }

  createDefaultDocumentationPages(partnerName) {
    return new Promise(async (resolve, reject) => {
      const data = [
        {
          "description": "<font face=\"Arial\" size=\"4\">Overview of APIs</font>",
          "effective_date": "2021-09-29",
          "sections": [
            {
              "title": "",
              "description": "",
              "sub_sections": []
            }
          ],
          "title": "Overview",
          "account": partnerName,
          "category_group": "",
          "category_name": "Getting Started",
          "partner": partnerName,
          "is_active": true
        },
        {
          "description": "",
          "effective_date": "2021-09-29",
          "sections": [
            {
              "title": "",
              "description": "",
              "sub_sections": []
            }
          ],
          "title": "Authentication Basics",
          "account": partnerName,
          "category_group": "",
          "category_name": "Authentication",
          "partner": partnerName,
          "is_active": true
        },
        {
          "description": "",
          "effective_date": "2021-09-29",
          "sections": [
            {
              "title": "",
              "description": "",
              "sub_sections": []
            }
          ],
          "title": "Credentials",
          "account": partnerName,
          "category_group": "",
          "category_name": "Authentication",
          "partner": partnerName,
          "is_active": true
        }
      ]

      for (let i = 0; i < data.length; i++) {
        await this.insertDefaultPages(data[i]);
        if (i === data.length - 1) {
          resolve('success');
        }
      }
    })
  }

  insertDefaultPages(payload) {
    return new Promise((resolve, reject) => {
      this._service.addItem(payload, 'v1', 'services', 'services', 'documentor').subscribe(response => {
        resolve('success');
      }, error => {
        resolve('failed');
      })
    })
  }

  ngOnInit() {

  }

}
